import { useEffect, useRef, useState } from 'react';

import { cn } from '../../helpers/shadCnUtils';

export interface TabItem {
  label: string;
  id: string;
  onClick: VoidFunction;
}

interface TabsProps {
  items: TabItem[];
  activeItem: string;
}

export const Tabs = ({ items, activeItem }: TabsProps) => {
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tabsRef.current) {
      const currentTab = tabsRef.current.querySelector(`[data-tab="${activeItem}"]`) as HTMLElement;
      if (currentTab) {
        setIndicatorStyle({
          left: currentTab.offsetLeft,
          width: currentTab.clientWidth,
        });
      }
    }
  }, [activeItem]);

  return (
    <div className="flex w-full items-center">
      <div
        className="relative mb-3 flex w-full flex-row border border-x-0 border-t-0 border-b-1 border-gray-300"
        ref={tabsRef}
      >
        {items.map((item) => {
          return (
            <div
              key={item.id}
              onClick={item.onClick}
              className={cn(
                'relative flex flex-1 cursor-pointer items-center justify-center px-2 py-1 text-xs font-semibold text-gray-600',
              )}
              data-tab={item.id}
              data-testid={item.id}
            >
              {item.label}
            </div>
          );
        })}

        <div
          className="bg-brandSecondary absolute bottom-0 h-0.5 transition-all duration-300 ease-in-out"
          style={indicatorStyle}
        />
      </div>
    </div>
  );
};
